import ExtensionAPI from 'echarts/lib/core/ExtensionAPI';
import GlobalModel from 'echarts/lib/model/Global';
import { parsePercent } from 'echarts/lib/util/number';

export function doubleYAxisHack(ecModel: GlobalModel, api: ExtensionAPI) {
  // 先判断有无蜂群图
  let hasBeeswarm = false;
  ecModel.eachSeriesByType('graph', function (graphSeries: BeesWarmGraphSeriesModel) {
    const layout = graphSeries.get('layout') as unknown;
    // 如果有蜂群图，则对所有右侧的Y轴做处理
    // HACK:这里的逻辑判断是暂时性的，需要考虑后续的扩展，比如其他系列与蜂群图混合等，比如蜂群图与roam没有一起出现等
    if (layout === 'beeswarm') {
      hasBeeswarm = true;
    }
  });

  if (!hasBeeswarm) {
    return;
  }

  ecModel.eachComponent('yAxis', function (yAxisModel: AxisBaseModel) {
    const { axis } = yAxisModel;
    const { position } = axis;
    if (position === 'right') {
      // 获取group
      const yAxisView = api.getViewOfComponentModel(yAxisModel);
      const { group } = yAxisView;
      // 获取应该处于的位置  width - grid.right
      const width = api.getWidth();
      // HACK:多gird可能有问题
      const grid = ecModel.getComponent('grid');
      const gridOption = grid.option;
      const gridRightParse = parsePercent(gridOption.right, width);
      const targetX = width - gridRightParse;
      // 实际处于的位置
      const currentX = gridOption.left + gridOption.width;
      group.traverse(d => {
        if (!d.anid) {
          return;
        }

        d.attr('x', d.x + targetX - currentX);
      });
    }
  });
}
